import React from 'react';
import { Plane, Smartphone, ChevronRight } from 'lucide-react';
import { Card } from '../components/ui/Card';
interface TravelScreenProps {
  onNavigate: (screen: string) => void;
}
export function TravelScreen({
  onNavigate
}: TravelScreenProps) {
  return <div className="min-h-screen bg-gray-50 pb-24" data-id="element-457">
      <header className="bg-[#003366] px-6 pt-12 pb-6 sticky top-0 z-10" data-id="element-458">
        <h1 className="text-2xl font-bold text-white" data-id="element-459">Services Voyage</h1>
      </header>

      <div className="px-6 py-6 space-y-6" data-id="element-460">
        {/* Flights Card */}
        <button onClick={() => onNavigate('flight-search')} className="w-full text-left group" data-id="element-461">
          <Card className="relative overflow-hidden group-active:scale-[0.98] transition-transform duration-200" data-id="element-462">
            <div className="absolute right-0 top-0 w-32 h-32 bg-[#003366]/5 rounded-full -mr-10 -mt-10 opacity-50" data-id="element-463"></div>

            <div className="relative z-10 flex items-center justify-between" data-id="element-464">
              <div className="flex items-start gap-4" data-id="element-465">
                <div className="p-3 bg-[#003366] text-white rounded-xl" data-id="element-466">
                  <Plane size={24} data-id="element-467" />
                </div>
                <div data-id="element-468">
                  <h3 className="text-lg font-bold text-gray-900" data-id="element-469">
                    Réserver un vol
                  </h3>
                  <p className="text-sm text-gray-500 mt-1 max-w-[200px]" data-id="element-470">
                    Recherchez et réservez directement avec votre carte ALAL
                  </p>
                </div>
              </div>
              <ChevronRight className="text-gray-400" data-id="element-471" />
            </div>
          </Card>
        </button>

        {/* eSIM Card */}
        <button onClick={() => onNavigate('esim')} className="w-full text-left group" data-id="element-472">
          <Card className="relative overflow-hidden group-active:scale-[0.98] transition-transform duration-200" data-id="element-473">
            <div className="absolute right-0 top-0 w-32 h-32 bg-[#D4A017]/10 rounded-full -mr-10 -mt-10 opacity-50" data-id="element-474"></div>

            <div className="relative z-10 flex items-center justify-between" data-id="element-475">
              <div className="flex items-start gap-4" data-id="element-476">
                <div className="p-3 bg-[#D4A017] text-white rounded-xl" data-id="element-477">
                  <Smartphone size={24} data-id="element-478" />
                </div>
                <div data-id="element-479">
                  <h3 className="text-lg font-bold text-gray-900" data-id="element-480">
                    Acheter une eSIM
                  </h3>
                  <p className="text-sm text-gray-500 mt-1 max-w-[200px]" data-id="element-481">
                    Restez connecté dans plus de 190 pays instantanément
                  </p>
                </div>
              </div>
              <ChevronRight className="text-gray-400" data-id="element-482" />
            </div>
          </Card>
        </button>

        {/* Promo / Info */}
        <div className="mt-8" data-id="element-483">
          <h3 className="text-sm font-semibold text-gray-900 mb-3" data-id="element-484">
            Pourquoi réserver avec ALAL ?
          </h3>
          <div className="grid grid-cols-2 gap-4" data-id="element-485">
            <div className="bg-white p-4 rounded-xl border border-gray-100" data-id="element-486">
              <div className="text-2xl mb-2" data-id="element-487">💸</div>
              <div className="font-medium text-sm text-gray-900" data-id="element-488">
                Sans frais cachés
              </div>
              <div className="text-xs text-gray-500" data-id="element-489">
                Tarifs transparents toujours
              </div>
            </div>
            <div className="bg-white p-4 rounded-xl border border-gray-100" data-id="element-490">
              <div className="text-2xl mb-2" data-id="element-491">⚡️</div>
              <div className="font-medium text-sm text-gray-900" data-id="element-492">
                Confirmation instantanée
              </div>
              <div className="text-xs text-gray-500" data-id="element-493">
                Billets livrés en secondes
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}